import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@/components/Search/SearchBar/searchBar.container"
    ).then((module) => ({
        default: module.SearchBar
    }))
);
